import Vue from 'vue'
import Vuex from 'vuex'
// import projectorSpec from '@/assets/data/projectorSpec.json'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

const state = {
  versionInfo: {
    verMajor: 2,
    verMinor: 5,
    verMinor2: 2,
    verDate: '20251023',
    verPhase: '' // base|alpha|beta|RC|release,
  },
  houseInfo: {
    // room size
    roomW: 1000,
    roomH: 500,
    roomD: 2000
  },
  graph: {
    // projector coordinates
    pjX: 250,
    pjY: 311,
    pjZ: 175,
    // screen size
    scrnW: 215,
    scrnH: 135.3,
    // board size
    boardW: 220,
    boardH: 140.3,

    f_s2d: null,
    f_d2s: null,
    vLensShift: {max: 0, min: 0},
    hLensShift: {max: 0, min: 0},
    vhLensShift: null,
    // 单位
    unit: 'T_METRE_M'
  },
  vLensShiftNow: 0,
  hLensShiftNow: 0,
  temVLensShift: {max: 0, min: 0},

  // 3d转化过之后的数据点
  drawData: null,
  blackDrawData: null,
  rangeDrawData: null,
  centerPointData: null,
  dashData: null,
  dashDataRemain: null,
  // 记录屏幕四个点的坐标（黑边的点）（只与主墙相交，不与上下左右墙相交）
  screen4Point: null,

  aspectRatio: null,

  userInputModelName: null,
  specificationMatchingModelData: null,
  installMatchingModelData: null,
  searchMatchingModelData: null,
  searchSelectedModelData: null,
  searchMatchingLensID: null,
  searchSelectedLensData: null,

  bmMatchingModelData: null,
  bmSelectedModelData: null,
  bmMatchingLensID: null,
  bmSelectedLensData: null,

  htmMatchingModelData: null,
  htmSelectedModelData: null,
  htmMatchingLensID: null,
  htmSelectedLensData: null,

  matchingModelData: null,
  selectedModelData: null,
  matchingLensID: null,
  selectedLensData: null,
  cateValue: 0,
  selectRatioData: null,

  cateRadio: 'bmRadio', // Bm:'bmRadio' Htm:'htmRadio'
  // 投影仪尺寸
  lenghProInit: 78.8,
  widthProInit: 50,

  // 屏幕大小
  screenSize: 100,
  // 1.576
  // 页面比例
  proportion: 0,
  brightness: 140,
  vAngleFlag: false,
  vAngle: 0,
  hAngleFlag: false,
  hAngle: 0,
  offset: 0,
  floor2bottom: 257.8,

  // 英寸转化
  inchCom: 2.54,
  // 黑边处理时的长宽
  initScreenSize: {
    w: 215,
    h: 135.3
  },
  pjImgType: 0,

  // Not used
  dist: 0,
  pjHeight: 0,
  f_vOffset: null,
  frontSlider: 0,
  oldT: {
    x: 0,
    y: 0
  },
  gain: '1.0',
  application: '0',
  // 主视图Change the projector position字段
  projectorChecked: true,
  screenMoveChecked: false,
  //  threeD Change the projector position字段
  threeDPJChecked: true,
  // condition页面Throw distance的checkbox字段
  throwDistanceChecked: false,
  // condition页面Screen Size的checkbox字段
  screenSizeChecked: false,
  // condition页面Screen Size的checkbox字段
  realThrowDistanceChecked: false,
  floorFootProjectorChecked: false,
  // condition页面ustWall、screenSizeChecked===true，throwDistanceChecked===true时T端值
  ustThrowDisSlidertMax: 0,
  ustScreenSizeMax: 0,
  // condition页面Screen Size的checkbox字段选中时，表示的屏幕的坐标
  pjXTip: 250,
  pjZTip: 175,
  blackSize: 0,
  centerPositionInit: null,
  projectorCheckedSide: true,
  projectorCheckedTop: true,
  // 表示点击Screen Position checkbox时，获取的屏幕左下角距下边的距离
  flToB: 0,
  flToL: 0,
  // 是否显示虚框
  dashFlag: false,
  // 判断屏幕是否接触frontView中的可移动区域
  isTouch: false,

  // 判断鼠标在哪个试图中，以触发键盘上下左右事件
  focusView: '',
  // isInFrontView: false,
  // isInSideView: false,
  // isInTopView: false,

  limitData: 0.00001,

  // view展示
  view: [{
    name: '3D View',
    value: 'right-down'
  }, {
    name: 'Side View',
    value: 'left-top'
  }, {
    name: 'Front View',
    value: 'right-top'
  }, {
    name: 'Top View',
    value: 'left-down'
  }],

  unitDataOptions: [{
    value: 'T_METRE_M',
    simplify: 'm'
  }, {
    value: 'T_MILLIMETER_MM',
    simplify: 'mm'
  }, {
    value: 'T_FEET_DECIMAL',
    simplify: 'ft'
  }, {
    value: 'T_FEET_FRACTION',
    simplify: 'ft'
  }, {
    value: 'T_INCH_DECIMAL',
    simplify: 'inch'
  }, {
    value: 'T_INCH_FRACTION',
    simplify: 'inch'
  }
  ],
  languageOptions: [
    {
      value: 'ja',
      label: 'T_TOP_TITLE_LANGUAGE_JA'
    },
    {
      value: 'zh',
      label: 'T_TOP_TITLE_LANGUAGE_ZH'
    },
    {
      value: 'en',
      label: 'T_TOP_TITLE_LANGUAGE_EN'
    },
    {
      value: 'de',
      label: 'T_TOP_TITLE_LANGUAGE_DE'
    },
    {
      value: 'fr',
      label: 'T_TOP_TITLE_LANGUAGE_FR'
    },
    {
      value: 'it',
      label: 'T_TOP_TITLE_LANGUAGE_IT'
    },
    {
      value: 'es',
      label: 'T_TOP_TITLE_LANGUAGE_ES'
    },
    {
      value: 'pt-PT',
      label: 'T_TOP_TITLE_LANGUAGE_PT'
    },
    {
      value: 'ru',
      label: 'T_TOP_TITLE_LANGUAGE_RU'
    },
    {
      value: 'nl',
      label: 'T_TOP_TITLE_LANGUAGE_NL'
    },
    {
      value: 'da',
      label: 'T_TOP_TITLE_LANGUAGE_DA'
    },
    {
      value: 'fi',
      label: 'T_TOP_TITLE_LANGUAGE_FI'
    },
    {
      value: 'no',
      label: 'T_TOP_TITLE_LANGUAGE_NO'
    },
    {
      value: 'sv',
      label: 'T_TOP_TITLE_LANGUAGE_SV'
    },
    {
      value: 'cs',
      label: 'T_TOP_TITLE_LANGUAGE_CS'
    },
    {
      value: 'hu',
      label: 'T_TOP_TITLE_LANGUAGE_HU'
    },
    {
      value: 'pl',
      label: 'T_TOP_TITLE_LANGUAGE_PL'
    },
    {
      value: 'sk',
      label: 'T_TOP_TITLE_LANGUAGE_SK'
    },
    {
      value: 'bg',
      label: 'T_TOP_TITLE_LANGUAGE_BG'
    },
    {
      value: 'et',
      label: 'T_TOP_TITLE_LANGUAGE_ET'
    },
    {
      value: 'lv',
      label: 'T_TOP_TITLE_LANGUAGE_LV'
    },
    {
      value: 'lt',
      label: 'T_TOP_TITLE_LANGUAGE_LT'
    },
    {
      value: 'ro',
      label: 'T_TOP_TITLE_LANGUAGE_RO'
    },
    {
      value: 'el',
      label: 'T_TOP_TITLE_LANGUAGE_EL'
    },
    {
      value: 'tr',
      label: 'T_TOP_TITLE_LANGUAGE_TR'
    },
    {
      value: 'sl',
      label: 'T_TOP_TITLE_LANGUAGE_SL'
    },
    {
      value: 'hr',
      label: 'T_TOP_TITLE_LANGUAGE_HR'
    },
    {
      value: 'sr',
      label: 'T_TOP_TITLE_LANGUAGE_SR'
    },
    {
      value: 'ar',
      label: 'T_TOP_TITLE_LANGUAGE_AR'
    },
    {
      value: 'he',
      label: 'T_TOP_TITLE_LANGUAGE_HE'
    },
    {
      value: 'zh-TW',
      label: 'T_TOP_TITLE_LANGUAGE_ZH_TW'
    },
    {
      value: 'ko',
      label: 'T_TOP_TITLE_LANGUAGE_KO'
    },
    {
      value: 'ta',
      label: 'T_TOP_TITLE_LANGUAGE_TA'
    },
    {
      value: 'vi',
      label: 'T_TOP_TITLE_LANGUAGE_VI'
    },
    {
      value: 'bi',
      label: 'T_TOP_TITLE_LANGUAGE_BI'
    }
  ],
  resolutionOptions: [
    {
      key: 'WUXGA',
      value: '1920 x 1200'
    },
    {
      key: 'WXGA',
      value: '1280 x 800'
    },
    {
      key: 'XGA',
      value: '1024 x 768'
    },
    {
      key: '4K',
      value: '3840 x 2160'
    },
    {
      key: '1080p',
      value: '1920 x 1080'
    },
    {
      key: 'FWXGA',
      value: '1366 x 768'
    },
    {
      key: 'Full HD',
      value: '1920 x 1080'
    },
    {
      key: 'SVGA',
      value: '800 x 600'
    },
    {
      key: 'SXGA+',
      value: '1400 x 1050'
    },
    {
      key: 'FullHD',
      value: '1920 x 1080'
    },
    {
      key: '1080p and 4KE',
      value: '1920 x 1080'
    },
    {
      key: 'Full HD and 4KE',
      value: '1920 x 1080'
    },
    {
      key: 'WUXGA and 4KE',
      value: '1920 x 1200'
    }
  ],
  theme: true,
  position: 0,
  browserType: '', // IE: 'ie; Edge: 'edge'; 其他:'other'
  isUSTWall: false,
  USTPjTop: 0, // 以front view为基准,
  SimplePjTop: 0,
  USTVDragFlag: false,
  USTLenshiftV: 0,
  FTUT2screenT: 9, // FTU上端到屏幕距离
  FTUT2screenTW: 10, // 白板外、FTU上端到屏幕距离
  FTUT2screenTN: 6, // 没有白板、FTU上端到屏幕距离
  FTUB2screenT: 5, // FTU下端到屏幕距离
  FTUHeight: 4, // FTU高度
  board2screenH: 2, // 白板下端到屏幕下端的最小距离
  board2screenW: 10, // 白板左/右端到屏幕左/右端的最小距离
  boardStatusTop: 0, // 白板top值
  touchInstall: true, // 是否能安装在白板外FTU
  fingerTouchStatus: false, // true:'on', false: 'off'
  FTULocationState: false, // true:'on', false: 'off'
  whiteboardStatus: false, // true:'on', false: 'off'
  showInputFlag: true,
  textDataView: '',
  keyStoneVertical: 0,
  keyStoneHorizontal: 0,
  outOfSpecVal: false,
  isOutOfSpec: false,
  isVAngleOut: false,
  languageDefault: 'en',
  searchTabActive: 'Search', // 'Search', 'Categolies', 'Specification', 'InstallCondition', 'Blending','CurvedSurface'
  ustLensToFrontPj: 0, // lx
  curveShape: '1', // '0':垂直, '1':水平
  curveDirection: '0', // '0':凹面, '1':凸面
  curveDepth: 0,
  isSimple: false,
  lensShiftRangeBool: false,
  lensShiftRange: false,
  brightnessGuide: false,
  curveCenter: null,
  DisableNone: false,
  curveRadius: 0,
  curveCentralAngle: 0,
  // 多台时投影仪的点坐标
  muPoints: null,
  SettingActive: ['1'],
  screenActive: ['1'],
  throwDisActive: ['1'],
  setfontSize: false,
  tabActiveName: 'Advanced', // 'Basic' 'Advanced'
  indAngleSwitch: false,
  indAngleRemainPints: null,
  cornerCorAreas: null,
  isOnCornerAreas: false,
  touchWallFlag: false,
  blendingAvaPoint: [],
  isProjectPosition: true,
  // 多台时表格数据
  simulateTabData: [],
  // 多台时表格中默认选项
  simulateTabSele: 0,
  blendingUnit: 'T_METRE_M',
  projectorSize: {
    w: 32,
    h: 16
  },
  blendingParam: {
    seLensData: null,
    vLensShift: null,
    hLensShift: null,
    vhLensShift: null,
    vLensShiftNow: 0,
    screenShape: '2', // '0':凹面, '1':凸面, '2': 平面,
    shapeShow: '2',
    radius: 1000,
    curveSelect: '0', // '0':中心角, '1':弧长, '2': 深度,
    angle: Math.PI / 1.5, // 中心角
    depth: '0', // 弧长
    arc: '0', // 深度
    screenHeight: 300,
    lensHeight: 150,
    lensShiftV: 0,
    lensHeightRate: {
      min: 0,
      max: 0
    },
    screenSize: {
      width: 670,
      height: 270
    },
    ratio: '16:10',
    position: '0',
    range: {
      min: 15,
      max: 45
    },
    number: {
      h: 4,
      v: 2
    }
  },
  blendingPositionLimit: {
    w: 0,
    h: 0
  },
  simulateSwitchFlag: 0, // 0表示平面多台，1表示曲面多台
  blendingEdgePoints: [],
  throwDisSlidertFormat: 0,
  throwDisSliderwFormat: 0,
  ratioScreenSizeMin: 0,
  ratioScreenSizeMax: 0,
  throwError: false,
  modeData: '0',
  fromBlending: false,
  throwDistance2screenSizWidth: 0, // install condition Throw distance 与 Screen Size Width的比值
  languageFlag: false, // 紧急对应maintenance修改后，top画面切换其它国家语言=>index页面还是maintenance语言
  mixRateHVal: '',
  mixRateVVal: '',
  contrastData: 0, // 実コントラスト
  distance2Wall: 0, // 镜头到墙面的当前距离(拖拽),
  curvedCorrectionScreen: {
    w: 0,
    h: 0,
    size: 0
  }, // 边缘融合凹面(凸面)箭头拖拽,屏幕大小的尺寸
  saveDate: '',
  key: 0,
  radioSelected: null,
  selectedKey: null,
  throwDisSliderMin: 0,
  throwDisSliderMax: 0,
  throwDisSliderw: 0,
  throwDisSlidert: 0,
  overlapH: 0,
  overlapV: 0,
  isHistoryRowClick: false,
  correctionNGInfoMSG: [],
  limitValue: 0, // OK/NG境界値
  lensList: [],
  wideStatus: 0, // ワイド端（スローレシオ最大）
  teleStatus: 0, // テレ端（スローレシオ最小）
  recommendLens: [], // 推荐镜头list
  blendingEdgePointsInit: [],
  cameraAssistSizeMin: 0,
  cameraAssistSizeMax: 0
}

export default new Vuex.Store({
  state,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/store.js